import * as React from 'react';
import { Link } from 'react-router-dom';

interface SelectedGradePanelProp {
  gradeLabel: string;
}

const SelectedGradePanel: React.FC<SelectedGradePanelProp> = ({
  gradeLabel,
}: SelectedGradePanelProp) => {
  return (
    <div className="selected-grade-block text-center p-x-lg xs-down-p-x-md p-y-md">
      <div className="selected-grade-lead-text">登録する学年</div>
      <div className="selected-grade-background">
        <div className="selected-grade-text">{gradeLabel}</div>
      </div>
      <div className="selected-grade-annotation col gray-dark text-left">
        <span className="size-sm">
          学年が正しくない場合は
          <Link to="/" className="back-to-grade-form">
            前のページ
          </Link>
          に戻り選択し直してください。
        </span>
      </div>
    </div>
  );
};

export default React.memo(SelectedGradePanel);
